import React, { useState, useEffect } from 'react';
import './patientdischarge.css';
import { useNavigate } from 'react-router-dom';
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import { Next } from 'react-bootstrap/esm/PageItem';

function DechargePatient({ onNext, onBack, patientData }) {
    const [formData, setFormData] = useState({
        diagnostic: '',
        recommendations: '',
        dischargeReason: '',
        dischargeType: '',
        healthStatus: '',
    });
    const [doctors, setDoctors] = useState([]);
    const [Userdata, setUserData] = useState();
    const [traitmentdata, setTraitmentData] = useState(null);
    const [billingData, setBillingData] = useState(null);
    const [dischargeData, setDischargeData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    // Fetch treatment data
    useEffect(() => {
        const fetchTraitmentData = async () => {
            try {
                const response = await api.get(`api/rooms/hospitalization/totalfee/${patientData._id}`);
                setTraitmentData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchTraitmentData();
    }, [patientData]);

    // Fetch logged user data
    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    // Fetch discharge data for patient if exists
    useEffect(() => {
        const fetchDischargeData = async () => {
            try {
                const response = await api.get(`/api/discharge/${patientData._id}`);
                setDischargeData(response.data.data);

                if (response.data) {
                    setFormData({
                        diagnostic: response.data.data.healthStatus,
                        recommendations: response.data.data.recommendations,
                        dischargeReason: response.data.data.dischargeReason,
                        dischargeType: response.data.data.dischargeType,
                    });
                } else {
                    setFormData({
                        diagnostic: '',
                        recommendations: '',
                        dischargeReason: '',
                        dischargeType: '',
                    });
                }
            } catch (error) {
                console.error("No discharge data");
            }
        };
        if (patientData) {
            fetchDischargeData();
        }
    }, [patientData]);


    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // Handle form submission (create or update discharge)
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form
        if (!formData.diagnostic || !formData.recommendations || !formData.dischargeReason || !formData.dischargeType) {
            toast.error("Veuillez remplir tous les champs requis.");
            return;
        }

        const dischargePayload = {
            admissionId: patientData._id,
            dischargeDate: new Date(),
            dischargeType: formData.dischargeType,
            dischargeReason: formData.dischargeReason,
            dischargedBy: formData.dischargedBy || Userdata._id,
            healthStatus: formData.diagnostic,
            recommendations: formData.recommendations,
            followUpDate: formData.followUpDate || null,
            paymentStatus: false,
        };

        try {
            let response;
            if (dischargeData) {
                // Update existing discharge
                response = await api.put(`/api/discharge/update/${dischargeData?._id}`, dischargePayload);

            } else {
                // Create new discharge
                response = await api.post('/api/discharge/create', dischargePayload);
                if (response.status === 200 || response.status === 201) {
                    // Create billing if discharge was successful
                    // Dans handleSubmit, modifiez la création de paymentData :
                    const paymentData = {
                        operationtype: 'Hospitalization Payment',
                        OperationId: response.data.data._id,
                        operationRef: "Hospitalization",
                        patientId: patientData.patientId?._id,
                        amount: traitmentdata?.grandTotal || 0,
                        currency: traitmentdata?.admission?.hospitalId?.hospital_currency || 'XOF',
                        purpose: 'Hospitalisation Fee',
                        hospitalId: traitmentdata?.admission?.hospitalId?._id || patientData.hospitalId,
                    };
                    const paymentResponse = await api.post('/clinic/createPayment', paymentData);
                    if (paymentResponse.status === 201) {
                        setBillingData(paymentResponse.data);
                    } else {
                        toast.error('Erreur lors de la création du billing.');
                    }
                }
            }

            if (response.status === 200 || response.status === 201) {
                toast.success("Informations enregistrées avec succès");
                setDischargeData(response.data.data);
                setShowModal(true);
            } else {
                toast.error('Erreur lors de l’enregistrement');
            }

        } catch (error) {
            console.log('Erreur lors de la soumission :', error);
            toast.error(error.response?.data?.message || 'Erreur lors de l’enregistrement de la décharge.');
        }
    };


    if (!patientData || !patientData._id) {
        return (
            <div className="frame">
                <h1 className="header">Aucun dossier patient sélectionné</h1>
                <button className="btn back" onClick={onBack}>Retour</button>
            </div>
        );
    }

    const handleConfirm = async () => {
        setShowConfirmModal(false);

        // 1. Récupération des IDs avec fallback sécurisé
        const roomId = traitmentdata?.room?.roomId || patientData.roomId?._id || patientData.roomId;
        const selectedBedNumber = traitmentdata?.admission?.bedNumber || patientData.bedNumber;

        // 2. Validation des données
        if (!roomId || !selectedBedNumber) {
            toast.error("Impossible de déterminer la chambre ou le lit");
            return;
        }

        // 3. Vérification du paiement
        if (dischargeData?.paymentStatus === false) {
            toast.error("Veuillez imprimer votre reçu et passer à la caisse pour finaliser le paiement");
            onNext(6); // Redirection vers la page de paiement
            return; // Important: arrêter l'exécution ici
        }

        // 4. Exécution de la décharge
        try {
            const response = await api.put(`/api/rooms/releasepatient/${roomId}`, {
                bedNumber: selectedBedNumber,
            });

            // 5. Gestion de la réponse
            if (response.status === 200 || response.status === 201) {
                toast.success(response.data.message || "Décharge finalisée avec succès !");
                // Optionnel: actualiser les données ou rediriger
                onNext(1); // Retour à l'accueil par exemple
            } else {
                throw new Error("Réponse inattendue du serveur");
            }
        } catch (error) {
            console.error('Erreur lors de la finalisation :', error);
            toast.error(error.response?.data?.message || "Erreur lors de la finalisation de la décharge");
        }
    };

    const handleCancel = () => {
        setShowConfirmModal(false);
        setShowModal(true);
    };

    return (
        <>
            <ToastContainer />

            <div className="patient-discharge-container">
                <h1 className="patient-discharge-header">Décharge du patient</h1>

                {dischargeData && dischargeData.paymentStatus === false && (
                    <div className="patient-discharge-alert patient-discharge-alert--warning" role="alert">
                    Veuillez imprimer votre reçu
                    <span
                        className="patient-discharge-alert__link"
                        onClick={() => onNext(6)}
                    >
                        ici
                    </span>
                    et passer à la caisse pour finaliser le paiement
                    </div>
                )}

                <form onSubmit={handleSubmit} className="patient-discharge-form">
                    <div className="patient-discharge-form-group">
                    <label htmlFor="dischargeReason">
                        <span>Motif de la décharge</span>
                    </label>
                    <select
                        id="dischargeReason"
                        name="dischargeReason"
                        value={formData.dischargeReason}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Sélectionner un motif</option>
                        <option value="Fin du traitement">Fin du traitement</option>
                        <option value="Transfert">Transfert</option>
                        <option value="Sortie contre avis médical">Sortie contre avis médical</option>
                        <option value="Décès">Décès</option>
                    </select>
                    </div>

                    <div className="patient-discharge-form-group">
                    <label htmlFor="dischargeType">
                        <span>Type de décharge</span>
                    </label>
                    <select
                        id="dischargeType"
                        name="dischargeType"
                        value={formData.dischargeType}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Sélectionner un type</option>
                        <option value="Sortie Normal">Sortie Normal</option>
                        <option value="Sortie sur Demande">Sortie sur Demande</option>
                        <option value="Sortie Contre avis médical">Sortie Contre avis médical</option>
                    </select>
                    </div>

                    <div className="patient-discharge-form-group">
                    <label htmlFor="diagnostic">
                        <span>Diagnostic final</span>
                    </label>
                    <textarea
                        id="diagnostic"
                        name="diagnostic"
                        value={formData.diagnostic}
                        onChange={handleChange}
                        placeholder="Entrez le diagnostic final"
                        required
                    />
                    </div>

                    <div className="patient-discharge-form-group">
                    <label htmlFor="recommendations">
                        <span>Recommandations (repos, médication…)</span>
                    </label>
                    <textarea
                        id="recommendations"
                        name="recommendations"
                        value={formData.recommendations}
                        onChange={handleChange}
                        placeholder="Entrez les recommandations médicales"
                        required
                    />
                    </div>

                    <div className="patient-discharge-actions">
                    {traitmentdata?.admission?.status === "Active" && (
                        <>
                        <button
                            type="submit"
                            className="patient-discharge-btn patient-discharge-btn--primary"
                        >
                            {dischargeData ? 'Mettre à jour la décharge' : 'Faire la décharge'}
                        </button>
                        
                        {dischargeData?.paymentStatus === true && (
                            <button
                            type="button"
                            className="patient-discharge-btn patient-discharge-btn--success"
                            onClick={() => setShowConfirmModal(true)}
                            >
                            Finaliser la Décharge
                            </button>
                        )}
                        </>
                    )}
                    
                    {onNext && (
                        <button
                        type="button"
                        className="patient-discharge-btn patient-discharge-btn--link"
                        onClick={() => onNext(1)}
                        >
                        Retour
                        </button>
                    )}
                    </div>
                </form>

                {/* Modal de paiement */}
                {showModal && (
                    <div className="patient-discharge-modal" tabIndex="-1" role="dialog">
                    <div className="patient-discharge-modal__dialog" role="document">
                        <div className="patient-discharge-modal__content">
                        <div className="patient-discharge-modal__header">
                            <h5 className="patient-discharge-modal__title">
                            Paiement requis
                            </h5>
                            <button 
                            type="button" 
                            className="patient-discharge-modal__close"
                            onClick={handleCancel}
                            >
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="patient-discharge-modal__body">
                            <p>
                            Patient:
                            <strong>
                                {patientData.patientId.firstname} {patientData.patientId.lastname}
                            </strong>
                            </p>
                            <p>
                            Montant à payer:
                            <strong>
                                {traitmentdata?.grandTotal ?? 'N/A'} {traitmentdata?.admission?.hospitalId?.hospital_currency}
                            </strong>
                            </p>
                            <div className="patient-discharge-modal__actions">
                            <button
                                type="button"
                                className="patient-discharge-btn patient-discharge-btn--primary"
                                onClick={handleConfirm}
                            >
                                Finaliser la Décharge
                            </button>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                )}

                {/* Modal de confirmation */}
                {showConfirmModal && (
                    <div className="patient-discharge-modal" tabIndex="-1" role="dialog">
                    <div className="patient-discharge-modal__dialog" role="document">
                        <div className="patient-discharge-modal__content">
                        <div className="patient-discharge-modal__header">
                            <h5 className="patient-discharge-modal__title">
                            Confirmation
                            </h5>
                            <button
                            type="button"
                            className="patient-discharge-modal__close"
                            onClick={handleCancel}
                            >
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="patient-discharge-modal__body">
                            <p>Voulez-vous vraiment finaliser la décharge ?</p>
                        </div>
                        <div className="patient-discharge-modal__footer">
                            <button
                            type="button"
                            className="patient-discharge-btn patient-discharge-btn--success"
                            onClick={handleConfirm}
                            >
                            Oui
                            </button>
                            <button
                            type="button"
                            className="patient-discharge-btn patient-discharge-btn--secondary"
                            onClick={handleCancel}
                            >
                            Annuler
                            </button>
                        </div>
                        </div>
                    </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default DechargePatient;